module.exports = __webpack_public_path__ + "static/media/Blackwell.e890557a.png";